import { forwardRef, type ComponentPropsWithoutRef, type ComponentRef } from "react";
import { Root, Indicator } from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

const Checkbox = forwardRef<ComponentRef<typeof Root>, ComponentPropsWithoutRef<typeof Root>>(
  ({ className, ...props }, ref) => (
    <Root
      ref={ref}
      className={cn(
        "h-5 w-5 shrink-0 rounded-sm border-2 border-border ring-offset-background transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
        className
      )}
      {...props}
    >
      <Indicator className="flex items-center justify-center text-current">
        <Check className="h-3.5 w-3.5" />
      </Indicator>
    </Root>
  )
);
Checkbox.displayName = Root.displayName;

export { Checkbox };
